// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"d4f43c3f","505":"5143aad1","738":"5b25e46a","833":"d4f43c3f"}[chunkId] + ".chunk.css";
};